import type { FC } from "react";

import {
  TOOLTIP_SHORTCUT_CLASS,
  type TTooltipShortcutProps,
} from "@/ui/components/overlay/Tooltip/Tooltip.config";
import { cn } from "@/ui/lib/utils";

export const TooltipShortcut: FC<TTooltipShortcutProps> = (
  {
    children,
    className,
  },
) => (
  <kbd
    data-component="TooltipShortcut"
    className={cn(TOOLTIP_SHORTCUT_CLASS, className)}
  >
    { children }
  </kbd>
);

TooltipShortcut.displayName = "TooltipShortcut";
